/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Incident_TimeInputs */

const en_case_field_incident_time = /** @type {(inputs: Case_Field_Incident_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time of incident`)
};

const pt_br2_case_field_incident_time = /** @type {(inputs: Case_Field_Incident_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora do sinistro`)
};

/**
* | output |
* | --- |
* | "Time of incident" |
*
* @param {Case_Field_Incident_TimeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_incident_time = /** @type {((inputs?: Case_Field_Incident_TimeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Incident_TimeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_incident_time(inputs)
	return pt_br2_case_field_incident_time(inputs)
});